import React, { useState } from "react";
import classnames from "classnames";
import "./InputElement.styles.css";
import { ColorBorderWrapper } from "components";
import { twMerge } from "tailwind-merge";

export interface InputElementProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  isError?: boolean;
  forUrlInput?: boolean;
  startElement?: React.ReactNode;
  classNames?: {
    mainContainer?: string;
    inputContainer?: string;
  };
}

function InputElement({
  className,
  classNames,
  startElement,
  isError,
  ...rest
}: InputElementProps) {
  const [showPasswordIcon, setShowPasswordIcon] = useState(true);

  return (
    <div className={twMerge(classnames("relative", classNames?.mainContainer))}>
      <ColorBorderWrapper
        noAnimation={rest.forUrlInput}
        isError={!!isError}
        className={classnames(
          classNames?.inputContainer,
          "h-full flex flex-row items-center",
          {
            "bg-gray-300": rest.forUrlInput && !rest.readOnly,
            "!bg-transparent": rest.readOnly,
          }
        )}
      >
        <div className="absolute translate-y-1/2 bottom-[50%] left-4">
          {startElement}
        </div>
        {rest.forUrlInput && (
          <div className="z-10 block  bg-[#F9FAFB] h-full rounded-r-none rounded-md border-l-0 border-t-0 border-b-0 border border-r-[1px] focus:outline-none border-gray-300 pointer-events-none select-none">
            <p className="px-3 py-[9.3px] h-full text-[#6B7280] text-sm">
              https://
            </p>
          </div>
        )}
        <input
          className={twMerge(
            classnames(
              "h-full",
              {
                "appearance-none block w-full px-4 py-3  placeholder-gray-400  text-sm  rounded-[6px] border-0":
                  !className,
                "!bg-transparent !placeholder-gray-700": rest.readOnly,
                "pr-7": rest.type === "password",
                "rounded-l-none": rest.forUrlInput,
              },
              { "!px-0": rest.readOnly },
              "focus:outline-none  ",
              className
            )
          )}
          {...rest}
          type={!showPasswordIcon ? "text" : rest.type}
          placeholder={!rest.disabled ? rest.placeholder : "No data"}
        />
      </ColorBorderWrapper>
      <div
        className={classnames(
          "absolute inset-y-0 right-0 pr-2 flex items-center text-sm leading-5 ",
          {
            hidden: rest.type !== "password",
          }
        )}
      >
        <button
          type="button"
          onClick={() => {
            setShowPasswordIcon((val) => !val);
          }}
          className="p-1 cursor-pointer text-[#78716C] hover:text-[#44403C] transition-colors"
          aria-label={showPasswordIcon ? "Show password" : "Hide password"}
        >
          {showPasswordIcon ? (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
          ) : (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L6.59 6.59m7.532 7.532l3.29 3.29M3 3l18 18" />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
}

export default InputElement;
